import { router } from "@/router";
import { deleteToken } from "./helpers";

export const handleUnauthorized = () => {
  deleteToken();

  router.navigate({
    to: "/login",
    search: { reason: "session-expired" },
    ignoreBlocker: true,
  });
};
